var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdgeware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "305px",
    height: "262px",
    viewBox: "0 0 305 262",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edgeware-main-logomark@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Site",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edgeware-V3---Press-(Desktop)",
    transform: "translate(-182.000000, -2016.000000)",
    fill: "#FF3B80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(159.000000, 1667.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brand/Outline/LogoMark-Copy-3",
    transform: "translate(23.781818, 349.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.709091,130.524562 L281.279972,91.9616036 L219.141904,91.9616036 L250.235694,38.5629588 L227.806574,0 L182.948336,0 L151.854545,53.3986448 L120.810268,0.0491247883 L75.9520289,0.0491247883 L53.5229096,38.6120836 L84.6166998,92.0107284 L22.4786318,92.0107284 L0,130.524562 L22.4291194,169.087521 L84.5671874,169.087521 L53.4733972,222.486166 L75.9025165,261 L120.760755,261 L151.854545,207.601355 L182.948336,261 L183.393947,261 L227.806574,261 L250.235694,222.486166 L219.141904,169.087521 L281.279972,169.087521 L303.709091,130.524562 Z M238.897353,38.5629588 L207.803563,91.9616036 L179.977591,91.9616036 L224.984367,14.6883117 L238.897353,38.5629588 Z M188.59275,9.77583286 L216.418721,9.77583286 L171.411945,87.0982496 L157.49896,63.1744777 L188.59275,9.77583286 Z M165.767531,96.8740824 L151.854545,120.797854 L104.025562,38.6120836 L117.938548,14.6883117 L165.767531,96.8740824 Z M64.8612503,38.5629588 L81.5964431,9.77583286 L109.422415,9.77583286 L92.6872217,38.5629588 L143.338412,125.612084 L115.51244,125.612084 L64.8612503,38.5629588 Z M28.1230459,101.737436 L90.2611139,101.737436 L104.1741,125.661208 L14.2100602,125.661208 L28.1230459,101.737436 Z M28.1230459,159.311688 L14.2100602,135.387916 L104.1741,135.387916 L90.2611139,159.311688 L28.1230459,159.311688 Z M115.51244,135.387916 L143.338412,135.387916 L95.5094288,217.573687 L67.6834573,217.573687 L115.51244,135.387916 Z M115.116341,251.273292 L81.5964431,251.273292 L67.6834573,227.34952 L101.203355,227.34952 L151.854545,140.300395 L165.767531,164.224167 L115.116341,251.273292 Z M188.59275,251.273292 L157.49896,197.874647 L171.411945,173.950875 L216.418721,251.273292 L188.59275,251.273292 Z M238.897353,222.486166 L224.984367,246.360813 L179.977591,169.038396 L207.803563,169.038396 L238.897353,222.486166 Z M174.283665,159.311688 L160.370679,135.387916 L256.028645,135.387916 L269.941631,159.311688 L174.283665,159.311688 Z M261.722572,125.661208 L261.27696,125.661208 L160.420191,125.661208 L174.333177,101.737436 L275.68507,101.737436 L292.420263,130.524562 L278.457764,154.448334 L261.722572,125.661208 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeware);
export default __webpack_public_path__ + "static/media/edgeware.1abb1f7365985ce4f9a7fe6c7c3807f7.svg";
export { ForwardRef as ReactComponent };